import React from "react";
import { Typography, Alert } from "@mui/material";
import __ from "src/utils/Translations";

const HistoryImportAlert = () => (
  <Alert severity="info" sx={{ mt: 2 }}>
    <Typography variant="subtitle1">
      {__(
        "Proces importu będzie odbywać się w tle, nawet jeżeli opuścisz te stronę"
      )}
    </Typography>
    <Typography variant="body2">
      {__(
        "Wszystkie importy znajdziesz w zakładce historia importów. Można tam sprawdzić szczegóły oraz status."
      )}
    </Typography>
  </Alert>
);

export default HistoryImportAlert;
